import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniabusonrentinmumbai() {



    const cardData =
    {
        keyword: 'Urbania Bus On Rent in Mumbai Airport',
        heading: 'Urbania on rent in pune: Urbania Bus On Rent in Mumbai Airport',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Urbania Bus On Rent in Mumbai Airport services for corporate groups, families, tourists, and event travelers needing comfortable and spacious group transportation to or from Mumbai Airport. Our well‑maintained Force Urbania bus fleet provides generous seating, powerful air‑conditioning, and smooth performance, making it ideal for airport pickups and drops, long‑distance travel, corporate outings, weddings, sightseeing, and outstation journeys between Pune and Mumbai Airport. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from key areas including Pune Airport, Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, and Pimpri Chinchwad, we ensure a safe, punctual, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for Urbania bus hire for Mumbai Airport transfers.',

        top: 'Top Places to Visit in Mumbai with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s iconic stone arch built to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it stands as a historic entry point for British governors and a symbol of colonial-era architecture. Today, visitors enjoy ferry rides to Elephanta Island, street food stalls, coastal photography, and a lively promenade filled with tourists, performers, and vendors. Its illuminated evenings create a stunning waterfront ambiance that reflects the essence of Mumbai."
  },
  {
    "title": "Marine Drive (Queen’s Necklace)",
    "description": "Marine Drive is Mumbai’s famous 3.6 km-long coastline, known for its curved boulevard that glitters like a ‘Queen’s Necklace’ at night. The promenade is ideal for morning jogs, romantic walks, cycling, and enjoying refreshing sea breezes. The Art Deco buildings lining the stretch add heritage value, making it one of the world’s largest collections of Art Deco architecture. Sunsets here are especially mesmerizing, drawing locals, tourists, and photographers to soak in the city’s vibrant coastal charm."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "CSMT, a UNESCO World Heritage Site, is an architectural masterpiece blending Victorian Gothic Revival and Indian traditional designs. Built in 1887, it is one of India’s busiest railway stations and a symbol of Mumbai’s historic importance. Its grand domes, stained glass windows, carvings of flora and fauna, and intricate pillars make it a living museum. The nighttime lighting further enhances its majesty, making it a must-visit landmark for history, architecture, and photography enthusiasts."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for its vibrant street food culture, local entertainers, and stunning sunsets. Visitors indulge in Mumbai’s iconic snacks like pav bhaji, bhel puri, and gola while enjoying camel rides, kite flying, and beach sports. The beach is also frequently visited by Bollywood celebrities who live in the surrounding areas. Its lively yet relaxed atmosphere makes it a perfect escape for families, couples, and tourists."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Shree Siddhivinayak Temple in Prabhadevi is one of India’s most revered Ganesha temples, believed to fulfill devotees’ wishes. The temple’s wooden doors depict Ashtavinayak carvings, and the gold-plated sanctum adds to its spiritual aura. Thousands queue up daily for darshan, including celebrities and leaders. During Ganesh Chaturthi, the entire area comes alive with devotional music, lights, and vibrant processions, showcasing Mumbai’s deep spiritual culture."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, situated on an islet connected by a narrow causeway, is a stunning Indo-Islamic structure honoring Sufi saint Pir Haji Ali Shah Bukhari. Surrounded by the sea on all sides, it offers breathtaking views and a serene spiritual experience. The white marble structure, religious hymns, and peaceful setting attract visitors of all faiths. The walk to the dargah during low tide is a unique experience, blending spirituality with natural beauty."
  },
  {
    "title": "Elephanta Caves",
    "description": "The Elephanta Caves, a UNESCO World Heritage Site located on Elephanta Island, feature ancient rock-cut sculptures dedicated primarily to Lord Shiva. The 5th–8th century caves include magnificent carvings like the massive Trimurti (three-faced Shiva), Nataraja, and various mythological scenes. Visitors reach the island via ferry from the Gateway of India, experiencing a combination of history, art, nature, and coastal adventure."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel that connects Mumbai’s western suburbs to South Mumbai. Its cable-stayed architecture, sweeping curves, and views of the Arabian Sea make it a visual delight. The bridge significantly reduces travel time, symbolizing Mumbai’s modern urban growth. The best time to view the Sea Link is during sunrise, sunset, or night when the bridge lights create a spectacular skyline view."
  },
  {
    "title": "Chor Bazaar",
    "description": "One of India’s oldest and most famous flea markets, Chor Bazaar is known for its antique furniture, vintage Bollywood posters, cameras, gramophones, lamps, and rare collectibles. Walking through its busy lanes offers a glimpse into Mumbai’s historic trade culture. Bargain hunters, interior designers, and collectors frequent the area to discover unique treasures. It remains a buzzing hotspot for culture, photography, and old-world charm."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread over 100 sq km, Sanjay Gandhi National Park is Mumbai’s green lung and a biodiversity hotspot. Visitors enjoy nature trails, lion and tiger safaris, boating, cycling routes, and the ancient Kanheri Caves inside the park. Home to leopards, deer, monkeys, and hundreds of bird species, it offers a jungle retreat in the middle of the city. The park is perfect for trekking, wildlife photography, and peaceful nature escapes."
  },
  {
    "title": "Mount Mary Church",
    "description": "The Basilica of Our Lady of the Mount, popularly called Mount Mary Church, is located atop a hill in Bandra offering beautiful views of the sea. The church is known for its stunning Gothic architecture, peaceful interiors, and the annual Bandra Fair held in September. Devotees across religions visit to seek blessings, light candles, and enjoy the serene surroundings. It is one of Mumbai’s most significant spiritual and cultural landmarks."
  }
],






"services": [
{
"name": "Urbania Bus on Rent in Mumbai Airport",
"description": "Urbania Bus on Rent in Mumbai Airport provides fully air-conditioned, spacious Urbania buses for hassle-free airport transfers. Ideal for corporate travelers, families, and group trips, this service ensures timely pickups and drops, comfortable seating, ample luggage space, and professional chauffeurs for a smooth journey to and from Mumbai Airport."
},
{
"name": "Mumbai Airport Urbania Hire",
"description": "Mumbai Airport Urbania Hire offers premium Urbania buses for airport transfers with luxurious interiors, climate-controlled comfort, and professional chauffeur service. Perfect for corporate teams, VIPs, and family groups, ensuring punctual and stress-free travel to domestic and international terminals."
},
{
"name": "Urbania Bus Rental Mumbai Airport",
"description": "Urbania Bus Rental Mumbai Airport provides reliable, air-conditioned Urbania buses for group airport transfers, corporate pick-ups, and family travel. The service emphasizes safety, timely arrivals, and convenience with trained chauffeurs and ample luggage accommodation."
},
{
"name": "Urbania AC Airport Transfer Mumbai",
"description": "Urbania AC Airport Transfer Mumbai offers fully air-conditioned Urbania buses for comfortable and seamless travel between the airport and city destinations. Perfect for VIP guests, corporate teams, and group travelers who prioritize comfort, reliability, and punctual service."
},
{
"name": "Corporate Airport Transfer Urbania Mumbai",
"description": "Corporate Airport Transfer Urbania Mumbai ensures professional and timely transport for business executives and corporate teams. Equipped with AC Urbania buses, experienced chauffeurs, and organized logistics, it provides a stress-free and efficient airport transfer solution."
},
{
"name": "Group Airport Transfer Urbania Mumbai",
"description": "Group Airport Transfer Urbania Mumbai provides spacious, air-conditioned Urbania buses suitable for transporting large groups efficiently. Ideal for corporate events, family trips, and group tours, this service focuses on comfort, punctuality, and safety for every passenger."
},
{
"name": "Luxury Airport Urbania Mumbai",
"description": "Luxury Airport Urbania Mumbai offers premium, well-maintained AC Urbania buses with plush interiors for VIP airport transfers. With professional chauffeurs, timely service, and a focus on passenger comfort, this option ensures a premium travel experience."
},
{
"name": "Affordable Airport Urbania Hire Mumbai",
"description": "Affordable Airport Urbania Hire Mumbai provides budget-friendly AC Urbania buses for airport pickups and drops without compromising comfort or reliability. Suitable for families, small corporate groups, and travelers seeking cost-effective transport solutions."
},
{
"name": "Chauffeur Driven Airport Urbania Mumbai",
"description": "Chauffeur Driven Airport Urbania Mumbai delivers stress-free airport travel with trained, verified chauffeurs. The service ensures smooth navigation, punctual arrivals, and a comfortable journey for corporate clients, tourists, and VIP travelers."
},
{
"name": "Mumbai Airport Pickup Drop Urbania",
"description": "Mumbai Airport Pickup Drop Urbania specializes in on-time airport transfers with spacious AC buses, luggage assistance, and courteous chauffeurs. Perfect for individuals, families, or corporate groups needing convenient, reliable transportation to and from the airport."
},
{
"name": "Reliable Airport Urbania Service Mumbai",
"description": "Reliable Airport Urbania Service Mumbai offers dependable airport transfer solutions with fully air-conditioned Urbania buses, trained drivers, and professional service. It ensures safe, timely, and comfortable travel for all types of passengers."
},
{
"name": "Best Airport Urbania Rental Mumbai",
"description": "Best Airport Urbania Rental Mumbai provides top-rated, fully AC Urbania buses for airport transfers with a focus on comfort, reliability, and professionalism. Ideal for VIPs, corporate clients, and family travelers seeking premium services."
},
{
"name": "Urbania for International Airport Transfer Mumbai",
"description": "Urbania for International Airport Transfer Mumbai specializes in transfers to and from international terminals with fully air-conditioned Urbania buses. Offering punctuality, comfort, and professional chauffeur service for business and leisure travelers."
},
{
"name": "Urbania Group Airport Travel Mumbai",
"description": "Urbania Group Airport Travel Mumbai offers organized, comfortable, and reliable airport transfers for large groups. The service includes air-conditioned buses, experienced drivers, and luggage-friendly vehicles to ensure a seamless travel experience."
},
{
"name": "Trusted Airport Urbania Hire Mumbai",
"description": "Trusted Airport Urbania Hire Mumbai delivers safe, punctual, and comfortable airport transfers with professional chauffeurs, fully AC buses, and excellent customer service. Ideal for corporate groups, families, and VIP travelers seeking reliability and convenience."
}
],
"tableData": [
["Urbania Bus on Rent in Mumbai Airport", "Mumbai Airport Urbania Hire"],
["Urbania Bus Rental Mumbai Airport", "Urbania AC Airport Transfer Mumbai"],
["Corporate Airport Transfer Urbania Mumbai", "Group Airport Transfer Urbania Mumbai"],
["Luxury Airport Urbania Mumbai", "Affordable Airport Urbania Hire Mumbai"],
["Chauffeur Driven Airport Urbania Mumbai", "Mumbai Airport Pickup Drop Urbania"],
["Reliable Airport Urbania Service Mumbai", "Best Airport Urbania Rental Mumbai"],
["Urbania for International Airport Transfer Mumbai", "Urbania Group Airport Travel Mumbai"],
["Trusted Airport Urbania Hire Mumbai", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania Bus On Rent at Mumbai Airport",
        "WhyChoosedescription": "Urbania Bus On Rent in Mumbai Airport is perfect for airport transfers, corporate trips, group travel, family outings, and outstation journeys, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Buses",
        "WhyChoosedescription": "Urbania Bus On Rent at Mumbai Airport provides well-maintained Force Urbania buses with modern interiors, air-conditioning, and ample legroom for smooth and comfortable travel."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania Bus On Rent in Mumbai Airport comes with skilled and courteous drivers familiar with Mumbai and nearby routes, ensuring safe, timely, and hassle-free transfers."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania Bus On Rent at Mumbai Airport for competitive rates with no hidden charges, making group and corporate travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania Bus On Rent in Mumbai Airport provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania Bus On Rent at Mumbai Airport is available for hourly rentals, full-day bookings, airport transfers, corporate travel, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Buses",
        "WhyChoosedescription": "All vehicles for Urbania Bus On Rent at Mumbai Airport are regularly cleaned, sanitized, and serviced to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Airport Transfers",
        "WhyChoosedescription": "Urbania Bus On Rent in Mumbai Airport guarantees on-time pickups and dependable service, ensuring smooth and stress-free travel to and from the airport."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania Bus On Rent at Mumbai Airport available for local and outstation travel?',
        answer: 'Yes, Urbania Bus On Rent in Mumbai Airport can be booked for airport transfers, city travel, corporate trips, and outstation journeys.',
    },
    {
        question: 'How can I book Urbania Bus On Rent at Mumbai Airport?',
        answer: 'You can book Urbania Bus On Rent in Mumbai Airport via phone, WhatsApp, or online for easy and quick reservations.',
    },
    {
        question: 'Why choose Urbania Bus On Rent at Mumbai Airport?',
        answer: 'Urbania Bus On Rent at Mumbai Airport offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania Bus On Rent at Mumbai Airport are licensed, trained, and experienced in handling Force Urbania buses safely.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania Bus On Rent at Mumbai Airport allows flexible pickup and drop locations across Mumbai and nearby areas.',
    },
    {
        question: 'Is Urbania Bus On Rent at Mumbai Airport available 24x7?',
        answer: 'Yes, Urbania Bus On Rent in Mumbai Airport operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania buses are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania Bus On Rent at Mumbai Airport accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free airport transfers.',
    },
    {
        question: 'Can Urbania buses be used for corporate, family, and outstation trips?',
        answer: 'Yes, Urbania Bus On Rent in Mumbai Airport is ideal for airport transfers, corporate travel, family outings, and group or outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sanjay Rao',
        feedback: 'Urbania Bus On Rent in Mumbai Airport provided a smooth and comfortable airport transfer. Professional driver and clean bus.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Sharma',
        feedback: 'We hired Urbania Bus On Rent at Mumbai Airport for a corporate group. Spacious, punctual, and excellent service.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Aditya Kulkarni',
        feedback: 'Urbania Bus On Rent in Mumbai Airport made our airport travel hassle-free and comfortable. Highly recommended.',
        rating: 5,
    },
];


























































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Bus On Rent in Mumbai Airport",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-mumbai-airport.jpg",
  "description": "Urbania Bus On Rent in Mumbai Airport offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation to and from Mumbai Airport.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-bus-on-rent-mumbai-airport"
  }
};







    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Urbania Bus On Rent in Mumbai Airport | AC & Luxury Urbania Airport Transfer 
  </title>

  <meta
    name="description"
    content="Book Urbania Bus On Rent in Mumbai Airport for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation to and from Mumbai Airport."
  />

  <meta
    name="keywords"
    content="Urbania Bus on Rent in Mumbai Airport, Mumbai Airport Urbania Hire, Urbania Bus Rental Mumbai Airport, Urbania AC Airport Transfer Mumbai, Corporate Airport Transfer Urbania Mumbai, Group Airport Transfer Urbania Mumbai, Luxury Airport Urbania Mumbai, Affordable Airport Urbania Hire Mumbai, Chauffeur Driven Airport Urbania Mumbai, Mumbai Airport Pickup Drop Urbania, Reliable Airport Urbania Service Mumbai, Best Airport Urbania Rental Mumbai, Urbania for International Airport Transfer Mumbai, Urbania Group Airport Travel Mumbai, Trusted Airport Urbania Hire Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/67.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniabusonrentinmumbai;